import React, { useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';
import { Row, Col, CardBody, Card, Alert, Container } from "reactstrap"
import { useSelector } from "react-redux";
import { getAllbaroFileList, sendAllbaroEmail } from "crud/auth.crud";
import moment from "moment";

import { ReactComponent as Warning } from 'assets/images/svg/warning.svg';
import { ReactComponent as Download } from 'assets/images/svg/download.svg';
import { ReactComponent as Delete } from 'assets/images/svg/delete.svg';

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

// action
import { registerUser, apiError, registerUserFailed } from "../../store/actions"

// Redux
import { connect } from "react-redux"
import { Link } from "react-router-dom"

// import images
import weaver from "../../assets/images/weaver.png";
import loading from "../../assets/images/loading.gif";

const ReportManagementScreen = () => {
  const selector = useSelector(state => state)

  const [company, setCompany] = useState(selector.auth?.user?.member_group?.[0]?.company_group)
  const [type, setType] = useState(selector.auth.user?.type || "")
  const [detailType, setDetailType] = useState(selector.auth?.user?.member_group?.[0]?.company_group?.company_detail?.[0]?.type || "")
  const [isAllbaroSend, setIsAllbaroSend] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [fileList, setFileList] = useState([])
  const newDate = new Date();
  const year = moment(newDate).format("YYYY");
  const prevYear = moment(newDate).format("YYYY") - 1;
  const API_URL = 'https://waveradmin.ropiklabs.com'
  const allbaroPath = API_URL + '/media/allbaro/' + company?.id + '/';
  const urls = {
    'collection' : prevYear + '-폐기물_수집ㆍ운반_실적보고서.pdf',
    'treatment' : year + '-수탁처리능력_확인서_폐기물_수탁확인서(',
    'many1' : year + '-음식물류_폐기물_발생_억제_및_처리_계획신고서.pdf',
    'many2' : prevYear + '-음식물류_폐기물_발생_억제_및_처리_실적보고서.pdf',
    'total1' : year + '-사업장_폐기물_배출자_신고서.pdf',
    'total2' : '-관리대장.xlsx',
  }
  const fileNames = {
    'collection' : '[시행규칙 별지 제50호서식] 폐기물 수집ㆍ운반 실적보고서(수집ㆍ운반업자용)-수집.hwp',
    'treatment' : '[시행규칙 별지 제5호서식] 수탁처리능력 확인서¸ 폐기물 수탁확인서-수집,처리장.hwp',
    'many1' : '[시행규칙 별지 제4호의10서식] 음식물류 폐기물 발생 억제 및 처리 계획신고서-300미만.hwp',
    'many2' : '[시행규칙 별지 제48호의4서식] 음식물류 폐기물 발생 억제 및 처리 실적보고-배출.hwp',
    'total1' : '[시행규칙 별지 제6호서식] 사업장폐기물배출자(신고서¸ 변경신고서)-배출.hwp',
    'total2' : '[시행규칙 별지 제35호의2서식] 음식물류 폐기물 관리대장-배출.hwp',
  }

  const getAllbaroFile = async () => {
    setIsLoading(true)
    let params = {
      id : company?.id,
      year : year
    }
    const response = await getAllbaroFileList(params);
    if(response.data.data?.length > 0){
      setIsAllbaroSend(true)
    }
    setIsLoading(false)
  }

  const openWebLink = (str) => {
    const url = `https://waveradmin.ropiklabs.com/media/sample/${str}`
    const win = window.open(url, '_blank');
    win.focus();
  };

  const fileDownload = async () => {
    if (type === 'collection') {
      openWebLink(fileNames.collection)
    } else if (type === 'treatment') {
      openWebLink(fileNames.treatment)
    } else if (type === 'emitter') {
      const companyDetail = company?.company_detail?.[0];
      if (companyDetail?.type === 'total') {
        openWebLink(fileNames.total1)
        openWebLink(fileNames.total2)
      } else if (companyDetail?.sector !== 'coffee' && companyDetail?.area >= 200) {
        openWebLink(fileNames.many1)
        openWebLink(fileNames.many2)
      } else if (companyDetail?.sector === 'coffee' && companyDetail?.area >= 300) {
        openWebLink(fileNames.many1)
        openWebLink(fileNames.many2)
      } else if (companyDetail.day_emission >= 300) {
        openWebLink(fileNames.many1)
        openWebLink(fileNames.many2)
      } else if (companyDetail.day_eat_count >= 100) {
        openWebLink(fileNames.many1)
        openWebLink(fileNames.many2)
      }
    }
  }

  const registFiles = (e) => {
    let filteredFiles
    for(let i=0;i<e.target.files.length;i++){
      if(fileList?.length > 0 && fileList?.map(item => item.name).indexOf(e.target.files[i].name) != -1){
        filteredFiles = (filteredFiles || [...e.target.files]).filter(data => data !== [...e.target.files][i]);
      }
    }
    setFileList([...fileList, ...(filteredFiles || e.target.files)])
  }

  const deleteFile = (item) => {
    setFileList(fileList.filter(data => data !== item))
  }

  const sendFax = async () => {
    if (confirm(`위 내용을 올바로에 신고하시겠습니까?`)) {
      if(fileList.length === 0){
        return ('파일을 등록해주세요.')
      }
      setIsLoading(true)

      try {
        const fd = new FormData();
        for (let i = 0; i < fileList.length; i++) {
          let newFile = new File([fileList[i]], `${encodeURI(fileList[i].name)}`, {type: fileList[i].type})
          fd.append('file_' + i, newFile);
        }
        fd.append('data', JSON.stringify({company_id: company.id, company_name: company.name, year: year}))

        const response = await sendAllbaroFax(params);
        if (response.data?.result === 'success') {
          alert(response.data?.msg)
          setFileList([])
          setIsAllbaroSend(true)
        }
      } catch (error) {
        console.error(error);
      }
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getAllbaroFile()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>신고사항 관리 | 웨이스트버스</title>
        </MetaTags>
        <div className="account-pages">
          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs maintitle="Home" title="마이웨버" breadcrumbItem="신고사항 관리" />

            <Row>
              <Col xs={12} style={{maxWidth: '34.25rem'}}>
                <Card className="overflow-hidden">
                  <CardBody className="p-4">
                    <div>

                      <div>
                        <p className="noMargin font-size-16 text-black font-weight-bold">{year}년 필요 구비 서류 확인</p>
                      </div>

                      <div className="mb-4">
                        <div className="download-container mt-2 d-flex flex-column justify-content-between" style={{ height: 'fit-content' }}>
                          <div className="d-flex align-items-top">
                            <Warning width={20} height={20} />
                            <div>
                              <p className="noMargin font-size-14 text-black padding-left-8">1. 신고양식을 다운로드 후 작성해주세요.</p>
                              <p className="noMargin font-size-14 text-black padding-left-8">2. 작성한 신고양식을 "PDF"로 만들어서 등록해주세요.</p>
                              <p className="noMargin font-size-14 text-black padding-left-8">3. "FAX로 제출하기" 버튼을 클릭하여 제출해주세요.</p>
                            </div>
                          </div>
                          <div className="waver-pagination-btn-group float-right d-flex justify-content-end mt-3">
                            <button className="waves-effect submit-btn btn btn-secondary font-size-14"
                              onClick={() => {
                                fileDownload()
                              }}
                            >신고양식 다운로드<Download className="margin-left-8" />
                            </button>
                          </div>
                        </div>
                        <p className="font-size-14 mt-4 mb-0">작성한 서류 파일첨부</p>
                        <label style={{ padding: '0.4rem 1rem', borderRadius: '0.2rem', margin: "18px 0", fontSize: 16 }} htmlFor="ex_file" className="btn btn-primary dropdown-toggle waves-effect waves-light">파일선택
                        </label>
                        <input style={{ display: "none" }} multiple type="file" accept=".pdf" id="ex_file" onChange={(e) => {
                          registFiles(e)
                        }} />

                        {fileList.length > 0 && fileList.map((item, index) => {
                          return (
                            <div className="file-confirm" key={index}>
                              <p className="noMargin">{item.name.substr(0,25) + '...'}</p>
                              <Delete className="margin-left-8 pointer" onClick={() => { deleteFile(item) }} />
                            </div>
                          )
                        })}
                      </div>

                      {isAllbaroSend ?
                      <div className="row">
                        <div className="col-12 text-end">
                          <p className="mb-0">서류를 이미 제출하셨습니다.</p>
                        </div>
                      </div>
                      :
                      <div className="row">
                        <div className="col-12 text-end">
                          <button
                            className="btn btn-primary w-md waves-effect waves-light"
                            onClick={() => {
                              sendFax()
                            }}
                          >
                            팩스로 제출
                          </button>
                        </div>
                      </div>
                      }

                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      {isLoading && <div style={{
        position: "absolute",
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        background: 'rgba(255, 255, 255, 0.6)',
        zIndex: 999,
        display: "flex",
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <img src={loading} alt="로딩중입니다." width={'5%'}></img>
      </div>}
    </React.Fragment>
  )
}

export default ReportManagementScreen
